const initialState = {
  logs: '',
  loadPreviewLogsPending: false,
  loadPreviewLogsError: null,
};

export default initialState;
